module.exports = __webpack_public_path__ + "media/Video-vplus.b1fa9ab8.mp4";